import type { ReviewStatus } from "admin/types/interfaces/conversation";

/**
 * Review status options with display labels and colors for the admin UI.
 */
// N.B. these hues must stay inside the set `src/index.css` remaps and inverts
// under `.dark` - the same rule `admin/types/constants/diagnostics.ts` documents
// for its badges. Raw Tailwind hues with no dark mapping (amber, slate, indigo,
// zinc) render as bright light-mode stickers on the nextgen dark theme.
export const REVIEW_STATUS_OPTIONS: {
  value: ReviewStatus;
  label: string;
  color: string;
}[] = [
  {
    value: "UNREVIEWED",
    label: "Unreviewed",
    color: "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200",
  },
  {
    value: "REVIEWING",
    label: "Reviewing",
    color: "bg-blue-100 text-blue-700 border-blue-300 hover:bg-blue-200",
  },
  {
    value: "TICKETED",
    label: "Ticketed",
    color: "bg-purple-100 text-purple-700 border-purple-300 hover:bg-purple-200",
  },
  {
    value: "WONT_FIX",
    label: "Won't Fix",
    color: "bg-red-100 text-red-700 border-red-300 hover:bg-red-200",
  },
  {
    value: "RESOLVED",
    label: "Resolved",
    color: "bg-green-100 text-green-700 border-green-300 hover:bg-green-200",
  },
  {
    value: "NO_ACTION",
    label: "No Action",
    color: "bg-orange-100 text-orange-700 border-orange-300 hover:bg-orange-200",
  },
];

/**
 * Get the display label for a review status value.
 */
export const getReviewStatusDisplay = (status: ReviewStatus | undefined): string => {
  const option = REVIEW_STATUS_OPTIONS.find((opt) => opt.value === status);
  return option ? option.label : "Unreviewed";
};

/**
 * Get the color classes for a review status value.
 */
export const getReviewStatusColor = (status: ReviewStatus | undefined): string => {
  const option = REVIEW_STATUS_OPTIONS.find((opt) => opt.value === status);
  return option ? option.color : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200";
};
